import { render } from "./Education.vue?vue&type=template&id=70957ed2&scoped=true"
import script from "./Education.vue?vue&type=script&lang=js"
export * from "./Education.vue?vue&type=script&lang=js"

import "./Education.vue?vue&type=style&index=0&id=70957ed2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70957ed2"]])

export default __exports__